import { useState } from 'react';
import { Modal } from './Modal';
import { fmtAmount, today } from '../lib/helpers';

export function AddTransactionModal({ type, partyId, partyName, onSave, onClose }) {
  const [amount, setAmount] = useState('');
  const [note, setNote]     = useState('');
  const [date, setDate]     = useState(today());
  const [saving, setSaving] = useState(false);

  const isCredit = type === 'credit';
  const label    = isCredit ? 'Credit (You will Get)' : 'Debit (You will Give)';
  const emoji    = isCredit ? '📥' : '📤';

  const submit = async () => {
    if (!amount || isNaN(+amount) || +amount <= 0) { alert('Enter a valid amount'); return; }
    setSaving(true);
    try {
      await onSave({ party_id: partyId, type, amount: +amount, note, date });
      onClose();
    } catch (e) { alert(e.message); }
    setSaving(false);
  };

  return (
    <Modal title={`${emoji} ${label}`} type={type} onClose={onClose}>
      <div className="form-group">
        <label className="form-label">Amount (₹)</label>
        <div className="form-prefix">
          <span className="form-prefix-symbol">₹</span>
          <input
            className={`form-input amount ${type}`}
            type="number" min="0" step="0.01"
            placeholder="0"
            value={amount} onChange={e => setAmount(e.target.value)}
            autoFocus
          />
        </div>
        {amount > 0 && (
          <div style={{ textAlign: 'center', marginTop: 4, fontSize: 12, color: 'var(--text-faint)' }}>
            {fmtAmount(+amount)}
          </div>
        )}
      </div>
      <div className="form-group">
        <label className="form-label">Party</label>
        <input className="form-input" value={partyName} disabled style={{ opacity: 0.7 }} />
      </div>
      <div className="form-group">
        <label className="form-label">Note (optional)</label>
        <input className="form-input" placeholder="e.g. Monthly payment, Goods sold..."
          value={note} onChange={e => setNote(e.target.value)} />
      </div>
      <div className="form-group">
        <label className="form-label">Date</label>
        <input className="form-input" type="date" value={date} onChange={e => setDate(e.target.value)} />
      </div>
      <button
        className={`btn btn-${isCredit ? 'green' : 'red'}`}
        style={{ width: '100%', justifyContent: 'center', padding: '12px', fontSize: 15 }}
        onClick={submit} disabled={saving}
      >
        {saving ? 'Saving…' : `Save ${isCredit ? 'Credit' : 'Debit'} Entry`}
      </button>
    </Modal>
  );
}
